import React, { useState } from "react";
import { API, fileUpload } from "../../config";
import { AddBankTransactionSchema } from "../../lib/Validation";
import Spin from "../../components/Spin";
import { Formik } from "formik";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { NumericFormat } from "react-number-format";
import { MaxLimit } from "../../lib/Misc";
import { cn } from "../../lib/utils";
// import { Loader2 } from "lucide-react";
import SearchSelect from "../../components/SearchSelect";
import { DateInputPicker } from "../../components/DateInputPicker";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";
import moment from "moment";

const AddTransaction = ({
  toggleShowAddTransaction,
  fetchBankTransactions,
  trustId,
}) => {
  const transactionType = [
    { label: "Credit", value: "1" },
    { label: "Debit", value: "0" },
  ];

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const [loading, setLoading] = useState(false);
  // const [accountData, setAccountData] = useState([]);

  // const getAccounts = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await get(
  //       `${API.GET_ACCOUNTS}?trust_id=${trustId ? trustId : ""}`
  //     );
  //     const account =
  //       data?.data &&
  //       data?.data?.length > 0 &&
  //       data?.data?.map((item) => {
  //         return {
  //           label: `${item?.provider?.providerName} (${item?.accountNumber}) - ${item?.container}`,
  //           value: item?.id,
  //         };
  //       });

  //     setAccountData(account ? account : []);

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // }, [trustId]);

  // useEffect(() => {
  //   getAccounts();
  // }, [getAccounts]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    // value.transaction_date = moment(value?.transaction_date).format("YYYY-MM-DD");
    value.amount = Number(`${value?.amount}`.replace(/,/g, ""));

    // formData.append("yodlee_account_id", value?.account ? value?.account : "");
    formData.append("amount", value?.amount ? value?.amount : "");
    formData.append("base_type", value?.base_type);
    formData.append(
      "transaction_date",
      value?.transaction_date
        ? moment(value?.transaction_date).format("DD-MM-YYYY")
        : ""
    );
    formData.append("trust_id", trustId ? trustId : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.ADD_BANK_TRANSACTION}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddTransaction();
        fetchBankTransactions();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        account: "",
        transaction_date: "",
        amount: "",
        base_type: "",
        description: "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddBankTransactionSchema}
    >
      {({
        values,
        setErrors,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => {
        return (
          <>
            {loading && <Spin expand={true} fullscreen={true}/>}
            <form
              onSubmit={handleSubmit}
              noValidate
              className="entry-section md:m-0 m-5"
            >
              <div className="form-box overflow-y-auto overflow-x-hidden p-4 border rounded-lg">
                <div className="grid grid-cols-2 gap-4 items-baseline">
                  {/* <div className="grid gap-2">
                    <Label htmlFor="account">
                      <CustomLabelText
                        required={false}
                        labelText="Account"
                        errorField={errors?.account}
                      />
                    </Label>
                    <div className="relative">
                      <SearchSelect
                        frameworks={accountData}
                        optionType={"Account"}
                        handleSelect={(e) => {
                          setFieldValue("account", e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.account &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={values?.account}
                      />
                      {loading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div> */}
                  <div className="grid gap-2">
                    <Label htmlFor="base_type">
                      <CustomLabelText
                        required={true}
                        labelText="Transaction Type"
                        errorField={errors?.base_type}
                      />
                    </Label>
                    <div className="relative">
                      <SearchSelect
                        frameworks={transactionType}
                        optionType={"Transaction Type"}
                        handleSelect={(e) => {
                          setFieldValue("base_type", e);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.base_type &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={values?.base_type}
                      />
                    </div>
                  </div>
                  <div className="grid gap-1">
                    <CustomLabelText
                      required={true}
                      labelText="Transaction Date"
                      errorField={errors?.transaction_date}
                    />
                    <DateInputPicker
                      date={
                        values?.transaction_date ? values?.transaction_date : ""
                      }
                      onSelect={(e) => {
                        setFieldValue("transaction_date", e);
                      }}
                      className={""}
                      inputClassName="w-full"
                      disabledDate={{ after: new Date() }}
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="amount">
                      <CustomLabelText
                        required={true}
                        labelText="Amount"
                        errorField={errors?.amount}
                      />
                    </Label>

                    <NumericFormat
                      type="text"
                      name="amount"
                      value={values?.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={true}
                      isAllowed={(values) => MaxLimit(values)}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.amount
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                            )
                      }
                    />
                  </div>
                  <div className="grid gap-2 col-span-2">
                    <Label htmlFor="description">
                      <CustomLabelText
                        required={true}
                        labelText="Description"
                        errorField={errors?.description}
                      />
                    </Label>
                    <Textarea
                      id="description"
                      name="description"
                      value={values?.description ? values?.description : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.description &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
                <Button type="submit" disabled={!isValid}>
                  Save
                </Button>
                <Button
                  className="reset ml-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleShowAddTransaction();
                  }}
                  variant="secondary"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </>
        );
      }}
    </Formik>
  );
};

export default AddTransaction;
